// API configuration
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3004';

// S3 configuration
export const S3_CONFIG = {
  bucketName: process.env.REACT_APP_S3_BUCKET_IMAGES || process.env.REACT_APP_S3_BUCKET || 'ohlyfans-images',
  region: process.env.REACT_APP_S3_REGION || 'us-east-1',
  endpoint: process.env.REACT_APP_S3_ENDPOINT, // No default - use AWS S3 when not specified
  accessKeyId: process.env.REACT_APP_S3_ACCESS_KEY,
  secretAccessKey: process.env.REACT_APP_S3_SECRET_KEY,
  // Use path style only for MinIO (when endpoint is localhost)
  s3ForcePathStyle: process.env.REACT_APP_S3_ENDPOINT ? process.env.REACT_APP_S3_ENDPOINT.includes('localhost') : false,
  signatureVersion: 'v4'
};

// Image folders
export const IMAGE_FOLDERS = {
  RAW: 'raw',
  FILTERED: 'filtered',
  MANUAL: 'manual',
  CROPPED: 'cropped'
};

// API endpoints
export const ENDPOINTS = {
  AUTH: {
    LOGIN: '/api/auth/login',
    REGISTER: '/api/auth/register',
    VERIFY: '/api/auth/verify'
  },
  INFLUENCERS: {
    BASE: '/api/influencers',
    BY_ID: (id) => `/api/influencers/${id}`
  },
  IMAGES: {
    BASE: '/api/images',
    BY_ID: (id) => `/api/images/${id}`,
    BY_FOLDER: (folder) => `/api/images?folder=${folder}`,
    TRANSITION: '/api/images/transition'
  },
  TRAINING: {
    SETTINGS: '/api/training/settings',
    START: '/api/training/start',
    STATUS: (jobId) => `/api/training/status/${jobId}`
  }
};
